module.exports = __webpack_public_path__ + "static/media/sunshineLogo.cab625ba.svg";